<div [className]="embed?.className" [ngStyle]="getEmbedStyles()">
  <h3 *ngIf="embed?.title">{{ embed.title }}</h3>
  <div class="w-100" [ngStyle]="{ height: embed?.height }">
    <ag-iframe [url]="embed?.targetUrl"></ag-iframe>
  </div>
</div>
